React = require 'react'
$ = require 'jquery'
_ = require 'underscore'
Util = require 'lib/util'
PopOver = require 'views/lib/pop-over'
l = require('lib/localize')
t = require('views/internal/recup-with-helpers')()
CanonicalDetailOverflowMenu = require 'views/canonical-detail/canonical-detail-overflow-menu'

{ OverflowButton } = require '@atlassian/trello-canonical-components/canonical-detail'

module.exports = class CanonicalDetailOverflow extends React.Component
  displayName: 'CanonicalDetailOverflow'

  constructor: ->
    @onOverflowClick = @onOverflowClick.bind(@)
    @state = {
      isVisible: false
      isMounted: false
    }
    @onHide = @onHide.bind(@)

  componentDidMount: ->
    @setState
      isMounted: true

  componentDidUpdate: (prevProps) ->
      if !_.isEqual(prevProps.menuItems, @props.menuItems)
        # cannot just rely on PopOver.isVisible because another card may
        # have its options updated which would then trigger the contents
        # of the open PopOver to change even if it was not for that card,
        # or the card may be removed because of being replied to.
        # setTimeout is needed because a race condition with removing the
        # popup and it updating when the menu options change (like changing
        # due date)
        setTimeout (=>
          if @state.isVisible && @state.isMounted && PopOver.isVisible
            PopOver.clearStack()
            PopOver.pushView
              reactElement: React.createElement CanonicalDetailOverflowMenu, { key: 'card-overflow-menu', menuItems: @props.menuItems }
        ), 0

  onHide: ->
    if @state.isMounted
      @setState
        isVisible: false

  onOverflowClick: (e) ->
    Util.preventDefault(e)

    if !@state.isVisible
      @props.trackOverflowMenuOpens(@props.cardId)

    @setState
      isVisible: true

    PopOver.toggle
      getViewTitle: -> l ['view title', 'actions']
      elem: $(e.currentTarget)
      reactElement: React.createElement CanonicalDetailOverflowMenu, { key: 'card-overflow-menu', menuItems: @props.menuItems }
      hidden: @onHide

  render: t.renderable ->
    { isVertical } = @props

    t.tag OverflowButton, {
      className: 'canonical-overflow-button'
      onClick: @onOverflowClick
      isVertical
    }



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-detail/canonical-detail-overflow.coffee